import { commonUtils } from '../common_utils';

const OP_DEALER_MIN_LOAN_AMOUNT = 2000;
const OP_DEALER_MAX_LOAN_AMOUNT = 150000;

export const opDealer = {
    removeGreenEffect() {
        $('.greenFadeEffectOpd').removeClass('updateSec');
    },
    loadYear(defaultYears) {
        $('#opdLoanPeriod').empty();

        let startYear = 1, endYear = 6;
        for (let year = startYear; year <= endYear; year++) {
            $('#opdLoanPeriod').append(new Option(year, year * 12));
        }

        $('#opdLoanPeriod').val(defaultYears);
    },
    slider() {
        let registerNumber = $('#opRegisterNumber').val();
        let defaultYear = $('#opdLoanPeriod').val();
        let loanAmount = $('#opdLoanAmount').val();

        $('.greenFadeEffectOpd').addClass('updateSec');

        if (loanAmount < OP_DEALER_MIN_LOAN_AMOUNT) {
            alert(`${Translations.ad_detail.finance.error.op_min_amount + OP_DEALER_MIN_LOAN_AMOUNT}€`);
            loanAmount = OP_DEALER_MIN_LOAN_AMOUNT;
            $('#opdLoanAmount').val(loanAmount);
        }

        if (loanAmount > OP_DEALER_MAX_LOAN_AMOUNT) {
            alert(`${Translations.ad_detail.finance.error.op_max_amount + OP_DEALER_MAX_LOAN_AMOUNT}€`);
            loanAmount = OP_DEALER_MAX_LOAN_AMOUNT;
            $('#opdLoanAmount').val(loanAmount);
        }

        opDealer.loadYear(defaultYear);
        defaultYear = $('#opdLoanPeriod').val();

        $.ajax({
            type: 'GET',
            url: Routing.generate('finance_op_dealer'),
            data: `registerNumber=${registerNumber}&loanAmount=${loanAmount}&loanPeriod=${defaultYear}`,
            success(data) {
                let loanData = data.opDealer;
                let installment = '-', effective = '-', nominal = '-';
                if (loanData) {
                    installment = commonUtils.numberFormatByLocale(loanData.monthlyPayment.toFixed(2));
                    effective = commonUtils.numberFormatByLocale(loanData.annualInterest.toFixed(2));
                    nominal = commonUtils.numberFormatByLocale(loanData.interest.toFixed(2));
                }

                $('#opd_monthly_payment').html(installment);
                $('#opd_air').html(effective);
                $('#opd_mir').html(nominal);

                setTimeout(opDealer.removeGreenEffect, 1000);
            },
        });
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));

        let registerNumber = $('#opRegisterNumber').val();
        let loanUrl = `https://autonostajanapuri.fi/api/autohaku?reg_number=${registerNumber}&brand=nettiauto`;
        window.open(loanUrl, '_blank');
    },
};
